import { getTranslateNsT } from "@/utils/getTranslateNsT";
import { AuthStatus } from "project-config/constants";

export function getAuthStatusTranslate(
  status: number,
  isStudent?: boolean,
  isPersonal?: boolean
) {
  const t = getTranslateNsT("profile");
  if (isStudent && isPersonal) return t("status-6-student");
  switch (status) {
    case AuthStatus.PersonalAuthSuccess:
    case AuthStatus.PersonalToEnterpriseFailed:
      return t("status-6");
    case AuthStatus.Changing:
      return isPersonal ? t("status-6") : t("enterprise_certify");
    case AuthStatus.PersonaChangeFailed:
    case AuthStatus.PersonalChanging:
      return t("status-6");
    case AuthStatus.EnterpriseAuthSuccess:
    case AuthStatus.EnterpriseChangeFailed:
      return t("enterprise_certify");
    default:
      return t("no_certify");
  }
}
